<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 100%;
  background-color: var(--color-chart);
}
</style>

<template>
  <div
    class="chart"
    :id="id"
  >
  </div>
</template>

<script>
import { widget } from '@/lib/charting_library'
import { sha256 } from 'js-sha256'
import Datafeed from '@/services/datafeed'
import Api from '@/util/api'
import Util from '@/util/util'
import MobileDetect from 'mobile-detect'

export default {
  props: { chart: Object },
  data () {
    return {
      tvWidget: null,
      prevState: '',
      id: this.chart.id,
      symbol: this.chart.symbol,
      exchange: this.chart.exchange
    }
  },
  mounted () {
    this.createChart()
  },
  beforeDestroy () {
    if (this.tvWidget) {
      const oldWidget = this.tvWidget
      this.tvWidget = null
      oldWidget.remove()
    }
  },
  computed: {
    chartSymbol () {
      return `${this.exchange}:${this.symbol}`.toUpperCase()
    },
    intervalId () {
      return 'interval_' + this.id
    }
  },
  methods: {
    // async initChart () {
    //   await Api.get(
    //     'user/tvdata?mode=term&cmd=load&token=' + this.$store.state.sys.token,
    //     { transformResponse: res => res }
    //   )
    //     .then(res => {
    //       this.createChart(res.data)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    createChart (tvdatastr) {
      let interval = localStorage.getItem(this.intervalId)

      if (!interval) {
        interval = '60'
      }

      const userId = sha256(this.$store.state.sys.email)
      const disabledFeatures = ['timeframes_toolbar']
      const md = new MobileDetect(window.navigator.userAgent)

      if (md.mobile()) {
        disabledFeatures.push('left_toolbar')
      }

      const widgetOptions = {
        debug: false,
        symbol: this.chartSymbol,
        datafeed: Datafeed, // our datafeed object
        interval,
        container: this.id,
        library_path: '/app/charting_library/',
        custom_css_url: '/app/chart.css',
        locale: this.$store.state.sys.lang,
        timezone: Util.getTimezone(),
        disabled_features: disabledFeatures,
        enabled_features: ['side_toolbar_in_fullscreen_mode'],
        charts_storage_url: process.env.VUE_APP_TV_URL,
        charts_storage_api_version: '1.1',
        client_id: 'capico.app',
        user_id: userId,
        fullscreen: false,
        theme: this.$store.getters.isThemeLight ? 'Light' : 'Dark',
        loading_screen: {
          foregroundColor: Util.getCssVariable('--color-accent'),
          backgroundColor: Util.getCssVariable('--color-chart')
        },
        autosize: true,
        studies_overrides: {},
        // auto_save_delay: 15,
        // load_last_chart: true,
        favorites: {
          intervals: ['1', '60', '1D'],
          chartTypes: ['Area', 'Candles']
        },
        overrides: {
          'symbolWatermarkProperties.transparency': 90,
          'mainSeriesProperties.showCountdown': true,
          'mainSeriesProperties.candleStyle.upColor': '#20b2aa',
          'mainSeriesProperties.candleStyle.drawBorder': false,
          'paneProperties.vertGridProperties.style': 2,
          'paneProperties.horzGridProperties.style': 2
        }
      }

      if (tvdatastr) {
        widgetOptions.saved_data = JSON.parse(tvdatastr)
        const shortName = this.symbol.replace('_', '/')

        if (
          widgetOptions.saved_data.charts[0].panes[0].sources[0].state.symbol
        ) {
          widgetOptions.saved_data.charts[0].panes[0].sources[0].state.symbol = this.chartSymbol
          widgetOptions.saved_data.charts[0].panes[0].sources[0].state.shortName = shortName
        }
      }

      // eslint-disable-next-line
      const tvWidget = new widget(widgetOptions)
      this.tvWidget = tvWidget

      tvWidget.onChartReady(() => {
        const onIntervalChanged = tvWidget.chart().onIntervalChanged()
        Util.applyChartOverrides(tvWidget, 'screener')

        // tvWidget.subscribe('onAutoSaveNeeded', () => {
        //   tvWidget.saveChartToServer(null, (err) => console.log(err), { defaultChartName: 'Auto' })
        // })

        onIntervalChanged.subscribe(null, interval => {
          localStorage.setItem(this.intervalId, interval)
        })

        tvWidget.subscribe('onTick', lastBar => {
          this.chart.lastPrice = lastBar.close
        })

        const onSymbolChanged = tvWidget.chart().onSymbolChanged()

        onSymbolChanged.subscribe(null, () => {
          const newSymbol = tvWidget.chart().symbol()

          if (newSymbol.split(/[:/]/).includes('undefined')) {
            tvWidget.chart().setSymbol(this.chartSymbol)
          }
        })
      })
    }
  }
}
</script>
